// material
import {
    Divider,
    Box,
    MenuItem, Select, Stack, Typography, Drawer, Container, IconButton
} from '@mui/material';
import './react-phone-number-input.css'
import { LoadingButton } from '@mui/lab';
import { useState, forwardRef, useEffect } from 'react';
import getActionVerificaNumero from 'src/actions/chats/whatsapp/getActionVerificaNumero';
import getActionChatInfo from 'src/actions/chats/getActionChatInfo';
import buscarCep from 'src/actions/chats/buscarCep';
import Iconify from 'src/components/Iconify';
import ModalAlerta from 'src/components/modal/ModalAlerta';
import { RowInput } from 'src/components/forms/RowInput';
import { formataNumeroCelular, maskCPF, maskDate, soNumeros } from 'src/utils/functions';
import actionEditarPerfil from 'src/actions/usuarios/actionEditarPerfil';
import { useSnackbar } from 'notistack';
import v2_actionListSectorsByClient from 'src/actions/v2/cliente/v2_actionListSectorsByClient';
import { Input } from 'src/@/components/ui/input';
import HorariosDeAtendimento from './HorarioAtendimento';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { Textarea } from 'src/@/components/ui/textarea';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
// ----------------------------------------------------------------------

export default function ModalEditarAgente({
    user,
    cliente,
    open,
    loading,
    onClose,
    callbackEdit,
    showSignupButton,
    dataUsuario
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [openModalAlerta, setOpenModalAlerta] = useState(false);
    const [mensagemModalAlerta, setMensagemModalAlerta] = useState('');
    const [loadingEditPerfil, setLoadingEditPerfil] = useState(false);
    const [listaSetores, setListaSetores] = useState([]);
    const [customServiceSchedule, setCustomServiceSchedule] = useState(false);
    const [scheduleService, setScheduleService] = useState([]);
    const [selectedRules, setSelectedRules] = useState([]);

    const rulesToShow = [
        {
            name: "Análise de atendimento",
            value: 'ia.analise-atendimento',
            category: "IA"
        },
        {
            name: "Autocompletar",
            value: 'ia.autocompletar',
            category: "IA"
        }
    ];

    useEffect(() => {
        if (dataUsuario?.userRules) {
            const filteredRules = dataUsuario.rules.filter(rule => 
                rulesToShow.some(r => r.value === rule)
            );
            setSelectedRules(filteredRules);
        }
    }, [dataUsuario]);

    const handleRuleChange = (value) => {
        setSelectedRules(prev => {
            if (prev.includes(value)) {
                return prev.filter(rule => rule !== value);
            } else {
                return [...prev, value];
            }
        });
    };

    const getRulesByCategory = () => {
        const categories = {};
        const filteredRules = rulesToShow.filter(rule => 
            user?.rules?.includes(rule.value)
        );

        console.log('user?.rules', user?.rules);
        console.log('rulesToShow', rulesToShow);

        console.log('filteredRules', filteredRules);
        
        filteredRules.forEach(rule => {
            if (!categories[rule.category]) {
                categories[rule.category] = [];
            }
            categories[rule.category].push(rule);
        });
        return categories;
    };

    const diasSemana = [
        { dia: "Domingo", numeroDia: 0 },
        { dia: "Segunda-feira", numeroDia: 1 },
        { dia: "Terça-feira", numeroDia: 2 },
        { dia: "Quarta-feira", numeroDia: 3 },
        { dia: "Quinta-feira", numeroDia: 4 },
        { dia: "Sexta-feira", numeroDia: 5 },
        { dia: "Sábado", numeroDia: 6 },
    ];

    const [dataAgente, setDataAgente] = useState({
        nome: dataUsuario?.firstName,
        sobrenome: dataUsuario?.lastName,
        email: dataUsuario?.email,
        usuario: dataUsuario?.username,
        nomeFantasia: dataUsuario?.nomeFantasia,
        telefone: dataUsuario?.telefone,
        usuarioId: dataUsuario?._id,
        setor_id: dataUsuario?.setor_id,
        config: {
            messageStandby: dataUsuario?.config?.messageStandby ? dataUsuario?.config?.messageStandby : '',
            customServiceSchedule: dataUsuario?.config?.customServiceSchedule ? dataUsuario?.config?.customServiceSchedule : false,
            scheduleService: dataUsuario?.config?.scheduleService ? dataUsuario?.config?.scheduleService : []
        }
    });



    async function getListSectors() {
        try {
            const response = await v2_actionListSectorsByClient(user?.clienteId);
            setListaSetores(response.data.data)
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {

        getListSectors();


        if (dataUsuario) {
            setDataAgente({
                nome: dataUsuario?.firstName,
                sobrenome: dataUsuario?.lastName,
                email: dataUsuario?.email,
                usuario: dataUsuario?.username,
                nomeFantasia: dataUsuario?.nomeFantasia,
                telefone: dataUsuario?.telefone,
                usuarioId: dataUsuario?._id,
                setor_id: dataUsuario?.setor_id,
                config: {
                    messageStandby: dataUsuario?.config?.messageStandby ? dataUsuario?.config?.messageStandby : '',
                    customServiceSchedule: dataUsuario?.config?.customServiceSchedule ? dataUsuario?.config?.customServiceSchedule : false,
                    scheduleService: dataUsuario?.config?.scheduleService
                }
            })
        }

        return () => {
            setDataAgente({
                nome: '',
                sobrenome: '',
                email: '',
                usuario: '',
                nomeFantasia: '',
                telefone: '',
                usuarioId: '',
                setor_id: '',
                config: {
                    messageStandby: '',
                    customServiceSchedule: false,
                    scheduleService: []
                }
            })
        }

    }, [dataUsuario]);



    const handleEditarPerfil = () => {
        setLoadingEditPerfil(true);

        let data = {
            usuarioId: dataAgente?.usuarioId,
            firstName: dataAgente?.nome,
            lastName: dataAgente?.sobrenome,
            telefone: `55${soNumeros(dataAgente?.telefone)}`,
            email: dataAgente?.email,
            username: maskUsername(dataAgente?.usuario),
            nomeFantasia: dataAgente?.nomeFantasia,
            setor_id: dataAgente?.setor_id,
            userRules: selectedRules,
            config: {
                messageStandby: dataAgente?.config?.messageStandby,
                customServiceSchedule: dataAgente?.config?.customServiceSchedule,
                scheduleService: dataAgente?.config?.scheduleService
            }
        }

        actionEditarPerfil(data).then(res => {
            if (res.data.error === true) {
                setLoadingEditPerfil(false)
                setTimeout(() => {
                    enqueueSnackbar(res.data.mensagem, { variant: 'error' });
                }, 1000);

            } else {
                setLoadingEditPerfil(false)
                enqueueSnackbar(res.data.mensagem, { variant: 'success' });
                callbackEdit()

            }
        }).catch((err) => {
            console.log(err)
            setLoadingEditPerfil(false)
            setTimeout(() => {
                enqueueSnackbar('Erro ao alterar perfil', { variant: 'error' });
            }, 1000);
        })
    }


    function maskUsername(str) {
        return str.split(' ').join('')
    }



    return (
        <div>

            <Drawer
                open={open}
                onClose={onClose}
                anchor="right"
                PaperProps={{ sx: { width: { xs: 1, sm: 600 } } }}
            >
                <Box sx={{ p: 3 }}>
                    <ModalAlerta
                        open={openModalAlerta}
                        mensagem={mensagemModalAlerta}
                        onClose={() => {
                            setOpenModalAlerta(false);
                            setMensagemModalAlerta('');
                        }}
                    />

                    <Stack justifyContent={'space-between'} direction="row" alignItems={'center'}>
                        <Typography variant="h6">Editar Agente</Typography>
                        <IconButton onClick={onClose} >
                            <Iconify icon={'eva:close-outline'} sx={{ width: 20, height: 20 }} />
                        </IconButton>
                    </Stack>

                    <Divider sx={{ mt: 2, mb: 2, borderStyle: 'dashed' }} />


                    <Stack spacing={{ xs: 1, md: 1 }}>
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                        <div className='w-full'>
                            <RowInput
                                label="Nome"
                                input={
                                    <Input
                                        onChange={e => setDataAgente({ ...dataAgente, nome: e.target.value })}
                                        value={dataAgente?.nome}
                                        fullWidth
                                    />
                                }
                            />
                            </div>
                                  <div className='w-full'>
                            <RowInput
                                label="Sobrenome"
                                input={
                                    <Input
                                        onChange={e => setDataAgente({ ...dataAgente, sobrenome: e.target.value })}
                                        value={dataAgente?.sobrenome}
                                        fullWidth
                                    />
                                }
                            />
                            </div>
                        </Stack>
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                            <div className='w-full'>
                                <RowInput
                                    label="Telefone"
                                    input={
                                        <Input
                                            onChange={e => setDataAgente({ ...dataAgente, telefone: e.target.value })}
                                            value={dataAgente?.telefone ? formataNumeroCelular(dataAgente?.telefone) : ""}
                                            fullWidth
                                        />
                                    }
                                />
                            </div>

                            <div className='w-full'>
                                <RowInput
                                    label="Usuário"
                                    input={
                                        <Input
                                            onChange={e => setDataAgente({ ...dataAgente, usuario: e.target.value })}
                                            value={dataAgente?.usuario}
                                            fullWidth
                                        />
                                    }
                                />
                                       </div>
                        </Stack>
             

                    <div className='flex flex-row gap-2'>
                        <div className='w-full'>
                            <RowInput
                                label="Nome Fantasia"
                                input={
                                    <Input
                                        onChange={e => setDataAgente({ ...dataAgente, nomeFantasia: e.target.value })}
                                        value={dataAgente?.nomeFantasia}
                                        fullWidth
                                    />
                                }
                            />
                        </div>

                        <div className='w-full'>
                            <RowInput
                                label="Email"
                                input={
                                    <Input
                                        onChange={e => setDataAgente({ ...dataAgente, email: e.target.value })}
                                        value={dataAgente?.email}
                                        fullWidth
                                    />
                                }
                            />
                        </div>


                    </div>



                    <Stack direction={{ xs: 'column', md: 'column' }} spacing={2}>



                        <RowInput
                            label="Setor"
                            input={<SelectZui
                                value={dataAgente?.setor_id}
                                list={listaSetores}
                                onChange={(e) => setDataAgente({ ...dataAgente, setor_id: e })}
                                itemSelect={(item) => (
                                    <SelectItem key={item._id} value={item._id}>
                                        {item.nome_setor || "undenfined"}
                                    </SelectItem>
                                )}
                            />}
                        />
                    </Stack>




                </Stack>

                <Divider sx={{ mt: 4, mb: 2, borderStyle: 'dashed' }} />

                <HorariosDeAtendimento
                    diasSemana={diasSemana}
                    dataAgente={dataAgente}
                    changeCustomScheduleService={value => {
                        setDataAgente((prevDataAgente) => ({
                            ...prevDataAgente,
                            config: {
                                ...prevDataAgente.config,
                                customServiceSchedule: value,
                            },
                        }));
                    }}
                    scheduleService={dataAgente?.config?.scheduleService || diasSemana.map(({ dia, numeroDia }) => ({
                        dia,
                        numeroDia,
                        ativo: true,
                        inicio: "08:00",
                        fim: "18:00",
                    }))}
                    changeScheduleService={(index, key, value) => {
                        const newScheduleService = [...dataAgente.config.scheduleService];
                        newScheduleService[index] = {
                            ...newScheduleService[index],
                            [key]: value,
                        };
                        setDataAgente({
                            ...dataAgente,
                            config: {
                                ...dataAgente.config,
                                scheduleService: newScheduleService,
                            },
                        });
                    }}

                />

                {/* <Divider sx={{ mt: 4, mb: 2, borderStyle: 'dashed' }} />

                <Typography variant="subtitle1" sx={{ mb: 2 }}>Regras de Usuário</Typography>
                {Object.entries(getRulesByCategory()).map(([category, categoryRules]) => (
                    <Box key={category} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>{category}</Typography>
                        <Stack direction="row" spacing={2} flexWrap="wrap">
                            {categoryRules.map((rule) => (
                                <Box key={rule.value} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <input
                                        type="checkbox"
                                        checked={selectedRules.includes(rule.value)}
                                        onChange={() => handleRuleChange(rule.value)}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <Typography variant="body2">{rule.name}</Typography>
                                </Box>
                            ))}
                        </Stack>
                    </Box>
                ))} */}

                <Divider sx={{ mt: 4, mb: 2, borderStyle: 'dashed' }} />

                <div>
                    <RowInput
                        label="Mensagem ausência de atendimento"
                        input={<Textarea
                            rows={4}
                            label="Mensagem de Standby"
                            defaultValue={dataAgente?.config?.messageStandby}
                            value={dataAgente?.config?.messageStandby}
                            onChange={e => setDataAgente({ ...dataAgente, config: { ...dataAgente.config, messageStandby: e.target.value } })}
                            fullWidth
                        />}
                    />
                </div>






                <Stack direction="row" sx={{ mt: 5, mb: 2 }}>
                    <ButtonLoading
                        className="w-full"
                        loading={loadingEditPerfil}
                        onClick={handleEditarPerfil}
                        sx={{ height: 30, fontSize: 12, borderRadius: 0.5 }}
                    // startIcon={<Iconify icon="material-symbols:save" />}
                    >
                        Salvar
                    </ButtonLoading>
                </Stack>

            </Box>

        </Drawer>
        </div >
    );
}
